//#region \0vite/modulepreload-polyfill.js
(function polyfill() {
	const relList = document.createElement("link").relList;
	if (relList && relList.supports && relList.supports("modulepreload")) return;
	for (const link of document.querySelectorAll("link[rel=\"modulepreload\"]")) processPreload(link);
	new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			if (mutation.type !== "childList") continue;
			for (const node of mutation.addedNodes) if (node.tagName === "LINK" && node.rel === "modulepreload") processPreload(node);
		}
	}).observe(document, {
		childList: true,
		subtree: true
	});
	function getFetchOpts(link) {
		const fetchOpts = {};
		if (link.integrity) fetchOpts.integrity = link.integrity;
		if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
		if (link.crossOrigin === "use-credentials") fetchOpts.credentials = "include";
		else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
		else fetchOpts.credentials = "same-origin";
		return fetchOpts;
	}
	function processPreload(link) {
		if (link.ep) return;
		link.ep = true;
		const fetchOpts = getFetchOpts(link);
		fetch(link.href, fetchOpts);
	}
})();
//#endregion
//#region frontend/lib/a11y.js
function getFocusableElements(container) {
	return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe")).filter((element) => !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length));
}
var trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
	const elements = getFocusableElements(container);
	const first = elements[0];
	const last = elements[elements.length - 1];
	removeTrapFocus();
	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;
		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.focusout = function() {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.keydown = function(event) {
		if (event.code.toUpperCase() !== "TAB") return;
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};
	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);
	elementToFocus.focus();
}
function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);
	if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;
	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;
	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}
function initDisclosureWidgets(summaries) {
	summaries.forEach((summary) => {
		summary.setAttribute("role", "button");
		summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));
		if (summary.nextElementSibling.getAttribute("id")) summary.setAttribute("aria-controls", summary.nextElementSibling.id);
		summary.addEventListener("click", (event) => {
			event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
		});
		summary.parentElement.addEventListener("keyup", onKeyUpEscape);
	});
}
//#endregion
//#region \0vite/preload-helper.js
var scriptRel = "modulepreload";
var assetsURL = function(dep, importerUrl) {
	return new URL(dep, importerUrl).href;
};
var seen = {};
var __vitePreload = function preload(baseModule, deps, importerUrl) {
	let promise = Promise.resolve();
	if (deps && deps.length > 0) {
		const links = document.getElementsByTagName("link");
		const cspNonceMeta = document.querySelector("meta[property=csp-nonce]");
		const cspNonce = cspNonceMeta?.nonce || cspNonceMeta?.getAttribute("nonce");
		function allSettled(promises) {
			return Promise.all(promises.map((p) => Promise.resolve(p).then((value) => ({
				status: "fulfilled",
				value
			}), (reason) => ({
				status: "rejected",
				reason
			}))));
		}
		promise = allSettled(deps.map((dep) => {
			dep = assetsURL(dep, importerUrl);
			if (dep in seen) return;
			seen[dep] = true;
			const isCss = dep.endsWith(".css");
			const cssSelector = isCss ? "[rel=\"stylesheet\"]" : "";
			if (!!importerUrl) for (let i = links.length - 1; i >= 0; i--) {
				const link = links[i];
				if (link.href === dep && (!isCss || link.rel === "stylesheet")) return;
			}
			else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) return;
			const link = document.createElement("link");
			link.rel = isCss ? "stylesheet" : scriptRel;
			if (!isCss) link.as = "script";
			link.crossOrigin = "";
			link.href = dep;
			if (cspNonce) link.setAttribute("nonce", cspNonce);
			document.head.appendChild(link);
			if (isCss) return new Promise((res, rej) => {
				link.addEventListener("load", res);
				link.addEventListener("error", () => rej(/* @__PURE__ */ new Error(`Unable to preload CSS for ${dep}`)));
			});
		}));
	}
	function handlePreloadError(err) {
		const e = new Event("vite:preloadError", { cancelable: true });
		e.payload = err;
		window.dispatchEvent(e);
		if (!e.defaultPrevented) throw err;
	}
	return promise.then((res) => {
		for (const item of res || []) {
			if (item.status !== "rejected") continue;
			handlePreloadError(item.reason);
		}
		return baseModule().catch(handlePreloadError);
	});
};
//#endregion
//#region frontend/lib/revive.js
function media({ query }) {
	const mediaQuery = window.matchMedia(query);
	return new Promise(function(resolve) {
		if (mediaQuery.matches) resolve(true);
		else mediaQuery.addEventListener("change", resolve, { once: true });
	});
}
function visible({ element }) {
	return new Promise(function(resolve) {
		const observer = new window.IntersectionObserver(async function(entries) {
			for (const entry of entries) if (entry.isIntersecting) {
				observer.disconnect();
				resolve(true);
				break;
			}
		});
		observer.observe(element);
	});
}
function idle() {
	return new Promise(function(resolve) {
		if ("requestIdleCallback" in window) window.requestIdleCallback(resolve);
		else setTimeout(resolve, 200);
	});
}
var islands = /* @__PURE__ */ Object.assign({
	"/frontend/islands/cart-drawer-items.js": () => __vitePreload(() => import("@theme/cart-drawer-items"), [], import.meta.url),
	"/frontend/islands/cart-drawer.js": () => __vitePreload(() => import("@theme/cart-drawer"), [], import.meta.url),
	"/frontend/islands/cart-items.js": () => __vitePreload(() => import("@theme/cart-items"), [], import.meta.url),
	"/frontend/islands/cart-note.js": () => __vitePreload(() => import("@theme/cart-note"), [], import.meta.url),
	"/frontend/islands/cart-remove-button.js": () => __vitePreload(() => import("@theme/cart-remove-button"), [], import.meta.url),
	"/frontend/islands/details-disclosure.js": () => __vitePreload(() => import("@theme/details-disclosure"), [], import.meta.url),
	"/frontend/islands/details-modal.js": () => __vitePreload(() => import("@theme/details-modal"), [], import.meta.url),
	"/frontend/islands/header-drawer.js": () => __vitePreload(() => import("@theme/header-drawer"), [], import.meta.url),
	"/frontend/islands/localization-form.js": () => __vitePreload(() => import("@theme/localization-form"), [], import.meta.url),
	"/frontend/islands/password-modal.js": () => __vitePreload(() => import("@theme/password-modal"), [], import.meta.url),
	"/frontend/islands/product-form.js": () => __vitePreload(() => import("@theme/product-form"), [], import.meta.url),
	"/frontend/islands/product-recommendations.js": () => __vitePreload(() => import("@theme/product-recommendations"), [], import.meta.url),
	"/frontend/islands/quantity-input.js": () => __vitePreload(() => import("@theme/quantity-input"), [], import.meta.url),
	"/frontend/islands/sticky-header.js": () => __vitePreload(() => import("@theme/sticky-header"), [], import.meta.url),
	"/frontend/islands/variant-radios.js": () => __vitePreload(() => import("@theme/variant-radios"), [], import.meta.url),
	"/frontend/islands/variant-selects.js": () => __vitePreload(() => import("@theme/variant-selects"), [], import.meta.url)
});
function revive(islands) {
	const observer = new window.MutationObserver((mutations) => {
		for (let i = 0; i < mutations.length; i++) {
			const { addedNodes } = mutations[i];
			for (let j = 0; j < addedNodes.length; j++) {
				const node = addedNodes[j];
				if (node.nodeType === 1) dfs(node);
			}
		}
	});
	async function dfs(node) {
		const tagName = node.tagName.toLowerCase();
		const potentialJsPath = `/frontend/islands/${tagName}.js`;
		if (/-/.test(tagName) && islands[potentialJsPath]) {
			if (node.hasAttribute("client:visible")) await visible({ element: node });
			const clientMedia = node.getAttribute("client:media");
			if (clientMedia) await media({ query: clientMedia });
			if (node.hasAttribute("client:idle")) await idle();
			islands[potentialJsPath]();
		}
		let child = node.firstElementChild;
		while (child) {
			dfs(child);
			child = child.nextElementSibling;
		}
	}
	dfs(document.body);
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}
//#endregion
//#region frontend/entrypoints/theme.js
var summaries = document.querySelectorAll("[id^=\"Details-\"] summary");
revive(islands);
initDisclosureWidgets(summaries);
document.addEventListener("alpine:init", () => {
	Alpine.data("layout", () => ({
		menu_open: false,
		menu_active: "",
		show_cart: false,
		nav_height: "",
		cart_data: {
			total: 0,
			has_items: false
		},
		updating_cart: false,
		recently_viewed: Alpine.$persist([]),
		init() {
			this.updateNavHeight();
		},
		updateNavHeight() {
			this.nav_height = this.$refs.header.getBoundingClientRect().bottom + "px";
		},
		openMenu(id) {
			this.menu_open = id;
			if (id === "search") setTimeout(() => {
				document.getElementById("search-input")?.focus();
			}, 100);
		},
		closeMenu(id) {
			if (!id || this.menu_open === id) {
				document.activeElement?.blur();
				this.menu_open = false;
			}
		},
		async addToCart(data) {
			this.updating_cart = true;
			const items = data.map((item) => {
				const line_item = {
					id: item.id,
					quantity: item.quantity ? item.quantity < 4 ? item.quantity > 0 ? item.quantity : 1 : 3 : 1
				};
				if (item.selling_plan) line_item.selling_plan = item.selling_plan.id;
				return line_item;
			});
			const url = window.routes.cart_add_url + ".js";
			if (await (await fetch(url, {
				method: "POST",
				credentials: "same-origin",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ items })
			})).json()) {
				if (location.pathname.includes("/cart")) {
					location.reload();
					return;
				}
				setTimeout(() => {
					this.openMenu("cart");
				}, 30);
				this.$dispatch("refresh-cart");
				this.updating_cart = false;
				return true;
			}
			this.updating_cart = false;
			return false;
		},
		viewProduct(handle) {
			const index = this.recently_viewed.indexOf(handle);
			if (index > 0) this.recently_viewed.splice(index, 1);
			if (index !== 0) {
				this.recently_viewed.unshift(handle);
				if (this.recently_viewed.length > 6) this.recently_viewed.pop();
			}
		},
		getSectionInnerHTML(html, selector) {
			return new window.DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML.trim();
		}
	}));
	Alpine.data("slider", (options) => ({
		swiper: null,
		thumbs: null,
		presets: {
			collection: {
				slidesPerView: 1.5,
				a11y: true,
				keyboard: { enabled: true },
				spaceBetween: 24,
				slidesOffsetBefore: 24,
				slidesOffsetAfter: 24,
				breakpoints: {
					768: {
						slidesPerView: 2.5,
						slidesPerGroup: 2,
						slidesOffsetBefore: 32,
						slidesOffsetAfter: 32
					},
					1024: {
						slidesPerView: 3.5,
						slidesPerGroup: 3,
						slidesOffsetBefore: 48,
						slidesOffsetAfter: 48
					},
					1280: {
						slidesPerView: 4.5,
						slidesPerGroup: 4,
						slidesOffsetBefore: 48,
						slidesOffsetAfter: 48
					}
				}
			},
			product: {
				slidesPerView: 1.125,
				spaceBetween: 4,
				a11y: true,
				autoHeight: true,
				autoplay: false,
				centerInsufficientSlides: true,
				keyboard: { enabled: true },
				navigation: {
					nextEl: ".swiper-button-next-custom",
					prevEl: ".swiper-button-prev-custom"
				},
				breakpoints: {
					768: { slidesPerView: 2.125 },
					1024: { slidesPerView: 1 }
				},
				on: {
					transitionStart: function() {
						document.querySelectorAll(".main-product-images video").forEach((video) => {
							video.pause();
						});
					},
					transitionEnd: function() {
						const activeIndex = this.activeIndex;
						const activeSlideVideo = document.querySelectorAll(".main-product-images .swiper-slide")[activeIndex].getElementsByTagName("video")[0];
						activeSlideVideo && activeSlideVideo.play();
					}
				}
			}
		},
		init() {
			if (options.thumbs) this.initThumbs();
			this.initSlider();
		},
		initSlider() {
			const config = options.preset ? this.presets[options.preset] : {
				slidesPerView: options.slidesPerView || 1,
				a11y: true,
				autoHeight: true,
				autoplay: false,
				initialSlide: options.initialSlide || 0,
				centeredSlides: options.centeredSlides || false,
				spaceBetween: options.spaceBetween || 24,
				slidesOffsetBefore: options.slidesOffsetBefore || 0,
				slidesOffsetAfter: options.slidesOffsetAfter || 0,
				loop: options.loop || false,
				keyboard: { enabled: true },
				navigation: {
					nextEl: ".swiper-button-next-custom",
					prevEl: ".swiper-button-prev-custom"
				}
			};
			if (options.autoplay) config.autoplay = { delay: options.autoplay };
			if (options.grid) {
				config.grid = { rows: 2 };
				config.slidesPerView = 4;
			}
			if (options.breakpoints) config.breakpoints = options.breakpoints;
			if (options.thumbs) config.thumbs = { swiper: this.thumbs };
			this.swiper = new Swiper(options.id, config);
		},
		initThumbs() {
			this.thumbs = new Swiper(options.thumbs, {
				slidesPerView: 8.125,
				spaceBetween: 4,
				freeMode: true,
				watchSlidesProgress: true,
				direction: "vertical"
			});
		}
	}));
	Alpine.data("product", () => ({
		show_sticky: false,
		async updateVariant(variant_id, price) {
			this.$data.selected.id = variant_id;
			this.$data.price = price;
			this.$data.selected.selling_plan = false;
			const base_url = window.location.pathname;
			window.history.replaceState({}, ``, `${base_url}?variant=${variant_id}`);
			const params = new URLSearchParams({
				variant: variant_id,
				sections: "main-product"
			});
			const url = base_url + "?" + params.toString();
			const response = await (await fetch(url, {
				method: "GET",
				credentials: "same-origin",
				headers: { "Content-Type": "application/json" }
			})).json();
			const product_images = this.$data.getSectionInnerHTML(response["main-product"], "[x-ref=\"product_images\"]");
			const product_price = this.$data.getSectionInnerHTML(response["main-product"], "[x-ref=\"product_price\"]");
			const product_info = this.$data.getSectionInnerHTML(response["main-product"], "[x-ref=\"product_info\"]");
			this.$refs.product_images.innerHTML = product_images;
			this.$refs.product_price.innerHTML = product_price;
			this.$refs.product_info.innerHTML = product_info;
		},
		updateSelection(e, option) {
			if (e.target.checked) this.$data.selected.selling_plan = option;
			else this.$data.selected.selling_plan = false;
		}
	}));
	Alpine.data("cart", (options) => ({
		percent: options.percent,
		timer: null,
		removeItem() {},
		handleChange(update) {
			if (this.timer !== null) clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.updateCart(update);
			}, 250);
		},
		async updateCart(update) {
			this.$data.updating_cart = true;
			const items = {
				line: update.index,
				quantity: update.quantity ?? 1
			};
			const url = window.routes.cart_change_url + ".js";
			await (await fetch(url, {
				method: "POST",
				credentials: "same-origin",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(items)
			})).json();
			this.refreshCart();
			this.$data.updating_cart = false;
		},
		async refreshCart() {
			const params = new URLSearchParams({ sections: "drawer-cart,cart-shipping,main-cart" });
			const url = window.location.pathname + "?" + params.toString();
			const response = await (await fetch(url, {
				method: "GET",
				credentials: "same-origin",
				headers: { "Content-Type": "application/json" }
			})).json();
			this.$refs.cart_form && (this.$refs.cart_form.innerHTML = this.$data.getSectionInnerHTML(response["drawer-cart"], "[x-ref=\"cart_form\"]"));
			this.$refs.cart_shipping && (this.$refs.cart_shipping.innerHTML = this.$data.getSectionInnerHTML(response["cart-shipping"], "[x-ref=\"cart_shipping\"]"));
			this.$refs.cart_items && (this.$refs.cart_items.innerHTML = this.$data.getSectionInnerHTML(response["main-cart"], "[x-ref=\"cart_items\"]"));
			this.$refs.cart_price && (this.$refs.cart_price.innerHTML = this.$data.getSectionInnerHTML(response["main-cart"], "[x-ref=\"cart_price\"]"));
			this.$refs.cart_discount && (this.$refs.cart_discount.innerHTML = this.$data.getSectionInnerHTML(response["main-cart"], "[x-ref=\"cart_discount\"]"));
		}
	}));
	Alpine.data("video_gallery", () => ({
		pauseVideos(e) {
			document.querySelectorAll("video").forEach((video) => {
				e.target !== video && !video.classList.contains("bg-video") && video.pause();
			});
		},
		["video"]: {
			["@play"](e) {
				this.pauseVideos(e);
			},
			["@click.prevent"](e) {
				e.target.paused ? e.target.play() : e.target.pause();
			}
		}
	}));
	Alpine.data("search", () => ({
		search: "",
		previous: "",
		selected: null,
		timer: null,
		results: null,
		selectOption() {
			if (this.selected) {
				const link = this.$refs.results_container.querySelector("[aria-selected=\"true\"] a");
				if (link) link.click();
			} else if (this.search.length > 1) this.$refs.search_form.submit();
		},
		navigateOptions(direction) {
			const options = Array.from(this.$refs.results_container.querySelectorAll("li"));
			const selected_index = options.findIndex((item) => item.dataset.id === this.selected);
			const is_up = direction === "up";
			let new_index = -1;
			if (is_up && !this.selected) return;
			if (is_up) new_index = selected_index === 0 ? options.length - 1 : selected_index - 1;
			else new_index = selected_index < 0 ? 0 : selected_index === options.length - 1 ? 0 : selected_index + 1;
			if (new_index > -1) {
				this.selected = options[new_index].dataset.id;
				options[new_index].scrollIntoView();
			}
		},
		handleChange() {
			if (this.timer !== null) clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.getSearch();
			}, 250);
		},
		async getSearch() {
			if (this.search.length > 0) {
				if (this.previous != this.search) {
					this.previous = this.search;
					this.selected = null;
					this.results = await this.getProductSearch();
				}
			} else {
				this.results = null;
				this.has_results = false;
			}
		},
		async getProductSearch() {
			const params = new URLSearchParams({
				sections: "get-search",
				type: "product",
				q: this.search
			});
			const url = window.Shopify.routes.root + "search?" + params.toString();
			const response = await (await fetch(url, {
				method: "GET",
				credentials: "same-origin",
				headers: { "Content-Type": "application/json" }
			})).json();
			const html = this.$data.getSectionInnerHTML(response["get-search"], "[x-ref=\"search_results\"]");
			return JSON.parse(html);
		},
		init() {
			this.$watch("menu_open", (value, old) => {
				if (value !== old) {
					this.results = null;
					this.search = "";
					this.previous = "";
					this.selected = null;
				}
			});
		}
	}));
	Alpine.data("collection", () => ({ handleSort() {
		this.$refs.sort_by.submit();
	} }));
	Alpine.data("oos_notify", () => ({
		oos_open: false,
		email: "",
		loading: false,
		submitted: false,
		async submitNotify() {
			if (this.$data.selected.id && this.email.length > 1 && !this.loading) {
				this.loading = true;
				const url = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Yb2igT";
				const variant_id = "$shopify:::$default:::" + this.$data.selected.id;
				const body = JSON.stringify({ data: {
					type: "back-in-stock-subscription",
					attributes: {
						channels: ["EMAIL"],
						profile: { data: {
							type: "profile",
							attributes: { email: this.email }
						} }
					},
					relationships: { variant: { data: {
						type: "catalog-variant",
						id: variant_id
					} } }
				} });
				fetch(url, {
					method: "POST",
					headers: {
						"accept": "application/vnd.api+json",
						"content-type": "application/vnd.api+json",
						"revision": "2025-07-15"
					},
					body
				}).then((response) => {
					this.loading = false;
					this.submitted = true;
				}).catch();
			}
		}
	}));
});
//#endregion
export { trapFocus as n, removeTrapFocus as t };
